module.exports = __webpack_public_path__ + "img/logo_easytag.f9301adc.png";